import { JobItem } from '../types';

export const sortByStarted = (a: JobItem, b: JobItem): number =>
  new Date(b.started).getTime() - new Date(a.started).getTime();
